import { AppBar, Toolbar } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";

import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { formatDateToShow } from "../../../common/Common";

export interface ICalculatedOffCyclePayrollSetupToolbar {
	// onSubmitCalculatedOffCyclePayrollButtonClickedHandler: () => void;
	onSubmitOrOverWriteCalculatedOffCyclePayrollButtonClickedHandler: (selectedItem: any) => void;
	onPrintCheckOrStubClaculatedOOffCyclePayrollButtonClickedHandler: (selectedItem: any) => void;
	onEditCalculatedOffCyclePayrollButtonClicked: () => void;
	onEmailStubCalculatedOffCyclePayrollButtonClicked: (selectedItem: any) => void;
	onProcessOffCyclePayrollClicked: () => void;
	onCancelProcessOffCyclePayrollClicked: () => void;
	offCyclePayrollNonCalculatedDataItems: any;
	selectedPayPeriod: any
	payPeriodEndDate: any
	payPeriodStartDate: any
	companyInfo: any;
	calculatedOffCyclePayrollTableData: any
}

const isDateBetween = (
	target: string,
	start: string,
	end: string
): boolean => {
	const targetDate = new Date(target);
	const startDate = new Date(start);
	const endDate = new Date(end);

	return targetDate >= startDate && targetDate <= endDate;
};

export const CalculatedOffCyclePayrollSetupToolbar: FC<ICalculatedOffCyclePayrollSetupToolbar> = ({
	// onSubmitCalculatedOffCyclePayrollButtonClickedHandler,
	onPrintCheckOrStubClaculatedOOffCyclePayrollButtonClickedHandler,
	onEditCalculatedOffCyclePayrollButtonClicked,
	onEmailStubCalculatedOffCyclePayrollButtonClicked,
	onSubmitOrOverWriteCalculatedOffCyclePayrollButtonClickedHandler,
	onProcessOffCyclePayrollClicked,
	offCyclePayrollNonCalculatedDataItems,
	onCancelProcessOffCyclePayrollClicked,
	selectedPayPeriod,
	payPeriodEndDate,
	payPeriodStartDate,
	companyInfo,
	calculatedOffCyclePayrollTableData
}) => {
	
	let companyBillingStartDate = companyInfo.billingStartDate ? new Date(companyInfo.billingStartDate) : null;
	const startDate = new Date(payPeriodStartDate);
	const endDate = new Date(payPeriodEndDate);
	// const isCompanyBillingStartDateLiesBetweenLoadedPeriod = companyBillingStartDate && companyBillingStartDate >= startDate && companyBillingStartDate <= endDate
	const isCompanyBillingStartDateLiesBetweenLoadedPeriod = companyBillingStartDate && companyBillingStartDate <= endDate
	
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
			}}
		>
			<Toolbar>
				<SplitButton
					options={["Print Check / Stub", "Print Stub Only", "Print Check Only"]}
					onClickHandler={onPrintCheckOrStubClaculatedOOffCyclePayrollButtonClickedHandler}
					testId="t4-print-button"
				/>
				<EnhancedButtonPrimeReact
					label="Edit"
					raised
					onClickHandler={onEditCalculatedOffCyclePayrollButtonClicked}
					style={{ marginLeft: "1rem", marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				// disabled={selectedPayPeriod && selectedPayPeriod.process ? true : false}
				/>
				{selectedPayPeriod && selectedPayPeriod.process ?
					<EnhancedButtonPrimeReact
						label="Save"
						raised
						onClickHandler={() => onSubmitOrOverWriteCalculatedOffCyclePayrollButtonClickedHandler('Save')}
						severity={EnhancedButtonPrimeReactSeverity.Success}
					/> : <SplitButton
						options={["Save", "Overwrite"]}
						onClickHandler={onSubmitOrOverWriteCalculatedOffCyclePayrollButtonClickedHandler}
						testId="t4-print-button"
					/>}
				<span>&nbsp;&nbsp;&nbsp;</span>
				<SplitButton
					options={["Email Stub", "Email Timesheet"]}
					onClickHandler={onEmailStubCalculatedOffCyclePayrollButtonClicked}
					testId="t4-print-button"
				/>
				{selectedPayPeriod && selectedPayPeriod.process ? <EnhancedButtonPrimeReact
					label="Cancel Payroll"
					raised
					onClickHandler={onCancelProcessOffCyclePayrollClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					disabled={calculatedOffCyclePayrollTableData && !calculatedOffCyclePayrollTableData.transactionReadyState}
				/> : isCompanyBillingStartDateLiesBetweenLoadedPeriod && <EnhancedButtonPrimeReact
					label="Process Payroll Now"
					raised
					onClickHandler={onProcessOffCyclePayrollClicked}
					style={{ marginLeft: "1rem" }}
					disabled={offCyclePayrollNonCalculatedDataItems && offCyclePayrollNonCalculatedDataItems.length > 0 ? true :
						calculatedOffCyclePayrollTableData && !calculatedOffCyclePayrollTableData.haveBank ? true : false}
				/>}

				{selectedPayPeriod && selectedPayPeriod.process &&
					<span
						style={{
							fontSize: "0.875rem",
							fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
							fontWeight: 500,
							letterSpacing: "0.00714em",
							// color: "rgba(0, 0, 0, 0.6)",
							color: "#ef4444",
							marginLeft: "1rem"
						}}>
						Payment Date: <b>{formatDateToShow(payPeriodEndDate)}</b>
					</span>}
			</Toolbar>
		</AppBar>
	);
};
